import { Card, Calendar, Modal, Typography } from "antd";
import { useState } from "react";
import moment from "moment";

const { Paragraph } = Typography;

function CalenderMonthlyReport(props: any) {
  const [selectedData, setSelectedData] = useState<any[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  console.log("object", props?.dataSource);
  // Function triggered on date select
  const onDateSelect = (date: any) => {
    const formattedDate = date.format("YYYY-MM-DD"); // Format selected date

    // Filter the dataSource based on the formattedDate
    const filtered = props?.dataSource?.filter((item: any) => {
      return (
        moment(item.date).format("YYYY-MM-DD") === formattedDate // Compare formatted dates
      );
    });

    setSelectedData(filtered || []); // Set selected data
    setIsModalVisible(true); // Open the modal
  };

  // Renders content for each date cell
  const dateCellRender = (date: any) => {
    const formattedDate = date.format("YYYY-MM-DD");

    // Filter the data for the current date
    const dailyData = props?.dataSource?.filter((item: any) => {
      return moment(item.date).format("YYYY-MM-DD") === formattedDate;
    });

    return (
      <div>
        {dailyData?.length > 0 ? (
          // Red badge for dates with content
          <div
            style={{
              backgroundColor: "#ff4d4f",
              color: "#fff",
              borderRadius: "4px",
              textAlign: "center",
              padding: "2px 0",
            }}
          >
            {dailyData.length} Task{dailyData.length > 1 ? "s" : ""}
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div>
      <Card>
        <Calendar onSelect={onDateSelect} dateCellRender={dateCellRender} />

        <Modal
          title="Details for Selected Date"
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
        >
          {selectedData?.length > 0 ? (
            selectedData?.map((item: any, index: number) => (
              <Card key={index} style={{ marginBottom: "10px" }}>
                <Paragraph>
                  <strong>posterContent</strong> {item?.posterContent || "N/A"}
                </Paragraph>
                <Paragraph>
                  <strong>celebrationDays:</strong>{" "}
                  {item.celebrationDays || "N/A"}
                </Paragraph>
                <Paragraph>
                  <strong>campaignsContent:</strong>{" "}
                  {item.campaignsContent || "N/A"}
                </Paragraph>
                <Paragraph>
                  <strong>impression:</strong> {item.impression || "N/A"}
                </Paragraph>
                <Paragraph>
                  <strong>leads:</strong> {item.leads || "N/A"}
                </Paragraph>
                <Paragraph>
                  <strong>amount:</strong> {item.amount || "N/A"}
                </Paragraph>
                <Paragraph>
                  <strong>status:</strong> {item.status || "N/A"}
                </Paragraph>
              </Card>
            ))
          ) : (
            <Paragraph>No data for this date.</Paragraph>
          )}
        </Modal>
      </Card>
    </div>
  );
}

export default CalenderMonthlyReport;
